import React from "react";
import Nav from "../Nav/Nav";
import { Outlet } from "react-router-dom";
import styles from "./Layout.module.scss";

const Layout = () => {
  return (
    <div className={styles.layout}>
      <Nav />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
